export default __webpack_public_path__ + "static/media/FINAL-ROCKETS-05.88612a9b.svg";